import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Breakdown from "src/views/Pages/Dashboard/Grow/Reports/Breakdown/Breakdown.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const BreakdownRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'breakdownreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.breakdown_report',
          component: Breakdown,
          meta: {
            prefix_permission: 'grow_breakdownreport',
          },
        },
      ],
    },
  ],
};

export default BreakdownRoutes;